/* eslint-disable @typescript-eslint/ban-ts-comment */
import { isNil } from "lodash";
import { FC } from "react";

import PointsSkeleton from "web/Layout/Common/Points/PointsSkeleton";
import __ from "web/Layout/Translations";

import formatNumber from "web/utils/data/parser/number/formatNumber";

import { useGetCustomerDetailsQuery } from "web/features/customer/customerApiSlice";
import { useGetBanksQuery } from "web/features/pointsBank/pointsBankApiSlice";

import classes from "./points.scss";

const PanelItemPoints: FC = () => {
  const { data: customerData } = useGetCustomerDetailsQuery();
  const { data: dataBanks, isLoading, isError } = useGetBanksQuery();
  const { total: totalPoints } = dataBanks || {};
  const { language } = customerData || {};
  const showSkeleton = isLoading || isError;

  const engClassName = language === "en_GB" ? classes.eng : "";

  const pointsText = __("pkt");
  const pointsFormatted =
    !isNil(totalPoints) && `${formatNumber(totalPoints)}`.replace(/ /g, "");

  return (
    <>
      {showSkeleton ? (
        <span className={`${classes.skeletonRoot} ${engClassName}`}>
          <PointsSkeleton compact />
        </span>
      ) : (
        <span className={`${classes.root} ${engClassName}`}>
          {pointsFormatted}
        </span>
      )}
      <span className={`${classes.text} ${engClassName}`}>{pointsText}</span>
    </>
  );
};

export default PanelItemPoints;
